import { type MetaFunction } from '@remix-run/node'
import personalUmbrella from './product-umbrella.jpg'

export const meta: MetaFunction = () => [
	{ title: 'Personal Umbrella Insurance' },
	{
		name: 'description',
		content:
			'A Personal Umbrella Insurance policy provides an extra layer of liability protection over your existing insurance policies.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Personal Umbrella</h1>

			<img
				src={personalUmbrella}
				alt="A gavel and a stack of money"
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Liability insurance is the coverage that protects you from the high cost
				of paying your legal liability for an accident that causes injury to a
				person or damage to property. Depending on the injury, it's difficult to
				tell what the judge or jury will award the person in a judgment against
				you.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				It has been said that there are more lawyers per capita in the United
				States than any other country. New York State is the state with the
				highest concentration of lawyers outside of Washington D. C. (which
				isn't its own state). With an increase in the number of lawyers, there
				is also a greater number of lawsuits.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Fortunately for many people, insurance is available to shift the
				significant cost associated with these lawsuits. It's common to wonder
				how much liability protection you should have. This is a tricky question
				to answer because we can't see the future. There are a few approaches
				that can be helpful in determining an appropriate amount of coverage.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				THE FUTURE EARNING POTENTIAL METHOD
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				For example:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Consider a situation where you have a sneezing fit or fall asleep at the
				wheel, causing an automobile accident where the person you hit becomes
				paralyzed and can no longer work to provide for their family. It's
				common in NY state for a breadwinner to earn upwards of $50,000 per
				year. If the person is fifteen years into their career (age 40) and has
				25 working years left, the math is simple: $50,000.00 x 25 years =
				$1,250,000.00 is the amount of money that that person would earn if they
				had continued to earn $50,000 for the next 25 years.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Many automobile insurance policies limit the per-person liability limit
				available to be purchased by the policyholder to a maximum of $250,000
				per person.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				If you selected the maximum limit available on your policy, you would
				have coverage under the policy and the insurer would pay out the policy
				limit, and then you would be responsible for the difference. If the Jury
				awards the widow and her children a judgment against you of the full
				$1,250,000.00, then you would only be responsible to may the remaining
				$1,000,000.00 out of pocket after the auto insurance policy has made
				payment.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				If you had purchased a personal umbrella policy, you would have extra
				liability protection above what is offered by your homeowner's and auto
				insurance. The limits available from a personal umbrella policy are
				typically available in even $1,000,000.00 increments. You could have a
				one, two, three, four, five million, or even a higher limit on your
				umbrella.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				THE ASSET PROTECTION METHOD
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				You can determine the amount you would lose if your entire asset base
				was wiped out instantly, by totaling the value of your owned assets
				(real estate, bank accounts, retirement funds, pension, etc.). Some
				people walk around with a target painted on their back based on
				occupation, role in the community, or by virtue of your status as a
				successful individual. If someone feels that you may have deep pockets,
				they may raise the amount asked for in a lawsuit.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Ultimately, in the environment that we live in, a person could sue for
				any reason, and make any demands. It may not go very far in the court
				system, but the mere cost of defending of yourself and your good name
				can grow very quickly.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The benefits of a personal umbrella policy far outweigh the costs. Many
				people are surprised to find that an umbrella can be obtained for under
				$20.00 a month. It is a way to sleep a lot better at night knowing that
				you are much less exposed.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Umbrellas are useful for more than just adding protection against a bad
				car accident or a personal lawsuit that would be covered by homeowners
				insurance. An umbrella would also be able to be written to go over top
				of insurance you have for a Boat, RV, Motorcycle, Snowmobile, ATV, or
				other toy.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The umbrella dovetails with the underlying policies that it goes over.
				It will have requirements for these underlying policies. It's common for
				an umbrella to require automobile liability limits of $250,000.00 per
				person for bodily injury liability, $500,000.00 per accident, and
				$100,000.00 for property damage. Further, it is likely to require that
				homeowners insurance be written with a liability limit of $300,000.
				Liability for your other policies will each need to meet the
				requirements set forth in the umbrella policy's provisions, or you may
				end up with a gap in coverage.
			</p>
		</main>
	)
}
